var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarMessagesIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7146 10.2143H10.8574M18.8574 4.5C19.4636 4.5 20.045 4.74082 20.4737 5.16947C20.9023 5.59812 21.1431 6.17951 21.1431 6.78571V18.2143C21.1431 18.8205 20.9023 19.4019 20.4737 19.8305C20.045 20.2592 19.4636 20.5 18.8574 20.5L15.43 20.4989L12.8083 23.1206C12.6115 23.3173 12.3497 23.4356 12.0719 23.453C11.7942 23.4705 11.5196 23.386 11.2997 23.2154L11.1923 23.1206L8.57057 20.4989L5.14314 20.5C4.53693 20.5 3.95555 20.2592 3.52689 19.8305C3.09824 19.4019 2.85742 18.8205 2.85742 18.2143V6.78571C2.85742 6.17951 3.09824 5.59812 3.52689 5.16947C3.95555 4.74082 4.53693 4.5 5.14314 4.5H18.8574Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.42785 11.357C7.99928 11.357 8.5707 10.7856 8.5707 10.2141C8.5707 9.64272 7.99928 9.07129 7.42785 9.07129C6.85642 9.07129 6.28613 9.64272 6.28613 10.2141C6.28613 10.7856 6.85642 11.357 7.42785 11.357ZM7.42785 15.9284C7.99928 15.9284 8.5707 15.357 8.5707 14.7856C8.5707 14.2141 7.99928 13.6427 7.42785 13.6427C6.85642 13.6427 6.28613 14.2141 6.28613 14.7856C6.28613 15.357 6.85642 15.9284 7.42785 15.9284Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7146 14.7861H10.8574",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarMessagesIcon);
export default __webpack_public_path__ + "static/media/SidebarMessagesIcon.a991e12c15fe60e3b8c68fc10646d5eb.svg";
export { ForwardRef as ReactComponent };